import { Col, FormGroup, Label, Row } from "reactstrap";
import SelectWithInput from "../../../Common/SelectWithInput";
import { AvField } from "availity-reactstrap-validation";
import CustomSelect from "../../../Common/CustomSelect";
import { getDefaultValueForSelect } from "../../../../helpers/utils";
import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import CheckboxCollapse from "../../../Common/CheckboxCollapse";
import FormByKpiIndicators from "./FormByKpiIndicators";

const FormByCostCPI = ({
  isLoading,
  offer_data,
  isFormSubmit,
  cost,
  suffix,
  setGroups,
  offer,
}) => {
  const [kpiIndicator, setKpiIndicator] = React.useState(
    cost?.cpi__kpi_indicator
  );
  const [isKpiIndicator, setIsKpiIndicator] = React.useState(
    !!cost?.cpi__kpi_indicator
  );

  const kpi_indicator_options = [
    { label: "Revenue", value: "Revenue" },
    { label: "Event %", value: "Event_%" },
    { label: "Retention", value: "Retention" },
    { label: "Cost per event", value: "Cost_per_event" },
    { label: "Average order value", value: "AOV" },
  ];

  const currency_type_options = [
    { label: "Avg per month", value: "Avg_per_month" },
    { label: "Last date", value: "Last_date" },
  ];

  const handleChangeKPI = val => {
    setKpiIndicator(val.value);
    setGroups(prev => {
      return prev.map(i => {
        if (`|${i.suffix}|` !== suffix) return i;

        return {
          ...i,
          suffix: Math.round(Math.random() * 10000).toString(),
          cpi__kpi_indicator: val.value,
        };
      });
    });
  };

  return (
    <React.Fragment>
      <Row>
        <Col md={6}>
          <FormGroup className="mb-3">
            <Label htmlFor="">CPI cost:</Label>
            <SelectWithInput
              select_name={"cpi__cost_currency" + suffix}
              options={offer_data.currencies}
              defaultValue={{
                label: cost?.cpi__cost_currency || "USD",
                value: cost?.cpi__cost_currency || "USD",
              }}
              required
              isLoading={isLoading}
              inputOptions={{
                name: "cpi__cost" + suffix,
                placeholder: "CPI cost",
                value: cost?.cpi__cost || "",
                type: "number",
                errorMessage: "CPI cost field is required!",
                validate: { required: { value: true } },
              }}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md="6">
          <FormGroup className="mb-3">
            <Label htmlFor="">Currency type:</Label>
            <CustomSelect
              name={"currency_type"}
              options={currency_type_options}
              defaultValue={
                getDefaultValueForSelect(offer?.currency_type) ||
                currency_type_options[0]
              }
              placeholder="Currency type..."
              classNamePrefix="select2-selection"
              errorMessage="Currency type field is required"
              required
              isLoading={isLoading}
              isFormSubmit={isFormSubmit}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md="6">
          <FormGroup className="mb-3">
            <CheckboxCollapse
              id={"cpi__kpi-indicator-checkbox" + suffix}
              title="KPI indicator"
              defaultChecked={!!cost?.cpi__kpi_indicator}
              onChange={val => setIsKpiIndicator(val)}
            >
              <CustomSelect
                name={"cpi__kpi_indicator" + suffix}
                options={kpi_indicator_options}
                defaultValue={getDefaultValueForSelect(
                  cost?.cpi__kpi_indicator
                )}
                placeholder="Select KPI indicator..."
                classNamePrefix="select2-selection"
                errorMessage="KPI indicator field is required"
                onChange={handleChangeKPI}
                required
                isLoading={isLoading}
                isFormSubmit={isFormSubmit}
              />
            </CheckboxCollapse>
          </FormGroup>
        </Col>
        <Col md="6">
          {isKpiIndicator && (
            <FormGroup className="mb-3">
              <CheckboxCollapse
                id={"cpi__cohort-days-id" + suffix}
                title="Cohort days"
                defaultChecked={!!cost?.cpi__kpi_is_cohort}
              >
                <AvField
                  name={"cpi__kpi_cohort_days_quantity" + suffix}
                  placeholder="Cohort days"
                  type="number"
                  value={cost?.cpi__kpi_cohort_days_quantity || ""}
                  className="form-control"
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Please, enter a cohort days",
                    },
                    min: {
                      value: 0,
                      errorMessage: "The cohort cannot be negative",
                    },
                  }}
                />
              </CheckboxCollapse>
            </FormGroup>
          )}
        </Col>
      </Row>

      {isKpiIndicator && (
        <FormByKpiIndicators
          kpiIndicator={kpiIndicator}
          cost={cost}
          suffix={suffix}
          prefix="cpi"
          isLoading={isLoading}
          isFormSubmit={isFormSubmit}
        />
      )}
    </React.Fragment>
  );
};

FormByCostCPI.propTypes = {
  isLoading: PropTypes.any,
  offer_data: PropTypes.any,
  isFormSubmit: PropTypes.any,
  cost: PropTypes.any,
  suffix: PropTypes.string,
  trackers: PropTypes.any,
  events: PropTypes.any,
  setGroups: PropTypes.func,
  offer: PropTypes.any,
};

export default FormByCostCPI;
